
// @ts-nocheck
import locale__builds_racent_frontend_website_nicsrs_locales_en_json from "../locales/en.json";
import locale__builds_racent_frontend_website_nicsrs_locales_zh_cn_json from "../locales/zh-cn.json";
import locale__builds_racent_frontend_website_nicsrs_locales_zh_tw_json from "../locales/zh-tw.json";
import locale__builds_racent_frontend_website_nicsrs_locales_ja_json from "../locales/ja.json";
import locale__builds_racent_frontend_website_nicsrs_locales_es_json from "../locales/es.json";
import locale__builds_racent_frontend_website_nicsrs_locales_fr_json from "../locales/fr.json";
import locale__builds_racent_frontend_website_nicsrs_locales_de_json from "../locales/de.json";
import locale__builds_racent_frontend_website_nicsrs_locales_ko_json from "../locales/ko.json";
import locale__builds_racent_frontend_website_nicsrs_locales_vn_json from "../locales/vn.json";
import locale__builds_racent_frontend_website_nicsrs_locales_th_json from "../locales/th.json";
import locale__builds_racent_frontend_website_nicsrs_locales_ru_json from "../locales/ru.json";
import locale__builds_racent_frontend_website_nicsrs_locales_tr_json from "../locales/tr.json";


export const localeCodes =  [
  "en",
  "zh-cn",
  "zh-tw",
  "jp",
  "es",
  "fr",
  "de",
  "kr",
  "vn",
  "th",
  "ru",
  "tr"
]

export const localeMessages = {
  "en": [{ key: "../locales/en.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_en_json), cache: true }],
  "zh-cn": [{ key: "../locales/zh-cn.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_zh_cn_json), cache: true }],
  "zh-tw": [{ key: "../locales/zh-tw.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_zh_tw_json), cache: true }],
  "jp": [{ key: "../locales/ja.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_ja_json), cache: true }],
  "es": [{ key: "../locales/es.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_es_json), cache: true }],
  "fr": [{ key: "../locales/fr.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_fr_json), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_de_json), cache: true }],
  "kr": [{ key: "../locales/ko.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_ko_json), cache: true }],
  "vn": [{ key: "../locales/vn.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_vn_json), cache: true }],
  "th": [{ key: "../locales/th.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_th_json), cache: true }],
  "ru": [{ key: "../locales/ru.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_ru_json), cache: true }],
  "tr": [{ key: "../locales/tr.json", load: () => Promise.resolve(locale__builds_racent_frontend_website_nicsrs_locales_tr_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": ""
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "iso": "en-US",
      "name": "English",
      "files": [
        "locales/en.json"
      ]
    },
    {
      "code": "zh-cn",
      "iso": "zh-CN",
      "name": "简体中文",
      "files": [
        "locales/zh-cn.json"
      ]
    },
    {
      "code": "zh-tw",
      "iso": "zh-TW",
      "name": "繁體中文",
      "files": [
        "locales/zh-tw.json"
      ]
    },
    {
      "code": "jp",
      "iso": "ja-JP",
      "name": "日本語",
      "files": [
        "locales/ja.json"
      ]
    },
    {
      "code": "es",
      "iso": "es-ES",
      "name": "Español",
      "files": [
        "locales/es.json"
      ]
    },
    {
      "code": "fr",
      "iso": "fr-FR",
      "name": "Français",
      "files": [
        "locales/fr.json"
      ]
    },
    {
      "code": "de",
      "iso": "de-DE",
      "name": "Deutsch",
      "files": [
        "locales/de.json"
      ]
    },
    {
      "code": "kr",
      "iso": "ko-KR",
      "name": "한국어",
      "files": [
        "locales/ko.json"
      ]
    },
    {
      "code": "vn",
      "iso": "vi-VN",
      "name": "Tiếng Việt",
      "files": [
        "locales/vn.json"
      ]
    },
    {
      "code": "th",
      "iso": "th-TH",
      "name": "ภาษาไทย",
      "files": [
        "locales/th.json"
      ]
    },
    {
      "code": "ru",
      "iso": "ru-RU",
      "name": "Русский",
      "files": [
        "locales/ru.json"
      ]
    },
    {
      "code": "tr",
      "iso": "tr-TR",
      "name": "Türkçe",
      "files": [
        "locales/tr.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "locales/",
  "rootRedirect": null,
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const nuxtI18nOptionsDefault = {
  "experimental": {
    "localeDetector": ""
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [],
  "defaultLocale": "",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "rootRedirect": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false
}

export const nuxtI18nInternalOptions = {
  "__normalizedLocales": [
    {
      "code": "en",
      "iso": "en-US",
      "name": "English",
      "files": [
        {
          "path": "locales/en.json"
        }
      ]
    },
    {
      "code": "zh-cn",
      "iso": "zh-CN",
      "name": "简体中文",
      "files": [
        {
          "path": "locales/zh-cn.json"
        }
      ]
    },
    {
      "code": "zh-tw",
      "iso": "zh-TW",
      "name": "繁體中文",
      "files": [
        {
          "path": "locales/zh-tw.json"
        }
      ]
    },
    {
      "code": "jp",
      "iso": "ja-JP",
      "name": "日本語",
      "files": [
        {
          "path": "locales/ja.json"
        }
      ]
    },
    {
      "code": "es",
      "iso": "es-ES",
      "name": "Español",
      "files": [
        {
          "path": "locales/es.json"
        }
      ]
    },
    {
      "code": "fr",
      "iso": "fr-FR",
      "name": "Français",
      "files": [
        {
          "path": "locales/fr.json"
        }
      ]
    },
    {
      "code": "de",
      "iso": "de-DE",
      "name": "Deutsch",
      "files": [
        {
          "path": "locales/de.json"
        }
      ]
    },
    {
      "code": "kr",
      "iso": "ko-KR",
      "name": "한국어",
      "files": [
        {
          "path": "locales/ko.json"
        }
      ]
    },
    {
      "code": "vn",
      "iso": "vi-VN",
      "name": "Tiếng Việt",
      "files": [
        {
          "path": "locales/vn.json"
        }
      ]
    },
    {
      "code": "th",
      "iso": "th-TH",
      "name": "ภาษาไทย",
      "files": [
        {
          "path": "locales/th.json"
        }
      ]
    },
    {
      "code": "ru",
      "iso": "ru-RU",
      "name": "Русский",
      "files": [
        {
          "path": "locales/ru.json"
        }
      ]
    },
    {
      "code": "tr",
      "iso": "tr-TR",
      "name": "Türkçe",
      "files": [
        {
          "path": "locales/tr.json"
        }
      ]
    }
  ]
}

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

